import { httpPatients } from "./http";

export const createPatientIdentifier = (data) =>
  httpPatients.post("/patient-identifiers/?format=json", data);

export const listPatientIdentifiers = (params) =>
  httpPatients.get("/patient-identifiers/?format=json", { params });